import React, { useState } from "react";
import QuestionStep from "./QuestionStep";
import { questions } from "../data/questions";

interface ServiceFormProps {
  onComplete: (answers: { [key: string]: string }) => void;
}

const ServiceForm: React.FC<ServiceFormProps> = ({ onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState<{ [key: string]: string }>({});

  const handleSelect = (optionId: string) => {
    setAnswers({ ...answers, [questions[currentStep].id]: optionId });
  };

  const handleNext = () => {
    if (currentStep < questions.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onComplete(answers);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const currentQuestion = questions[currentStep];
  const isAnswered = !!answers[currentQuestion.id];
  const progress = ((currentStep + 1) / questions.length) * 100;

  return (
    <div className="max-w-2xl mx-auto px-5 py-5 text-gray-800">

      {/* Progress */}
      <div className="mb-8">
        <span className="text-sm text-gray-500 mb-2 block">
          Question {currentStep + 1} of {questions.length}
        </span>
        <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-600 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <QuestionStep
        question={currentQuestion.question}
        helpText={currentQuestion.helpText}
        options={currentQuestion.options}
        selectedOptionId={answers[currentQuestion.id] || null}
        onSelect={handleSelect}
      />

      {/* Buttons */}
      <div className="flex justify-between gap-3 mt-8">
        {currentStep > 0 && (
          <button
            onClick={handleBack}
            className="px-6 py-3 bg-gray-100 text-gray-600 border border-gray-300 rounded-lg text-base font-medium cursor-pointer hover:bg-gray-200 transition-colors"
          >
            ← Back
          </button>
        )}
        <button
          onClick={handleNext}
          disabled={!isAnswered}
          className={`flex-1 px-6 py-3 text-white border-none rounded-lg text-base font-medium transition-colors
            ${isAnswered
              ? 'bg-blue-600 cursor-pointer hover:bg-blue-700'
              : 'bg-gray-400 cursor-not-allowed'
            }`}
        >
          {currentStep < questions.length - 1 ? 'Next →' : 'Get Recommendations'}
        </button>
      </div>
    </div>
  );
};

export default ServiceForm;
